import { useCallback, useEffect, useState } from "react";

export function useVolume(audioRef) {
  const [volume, setVolume] = useState(80);
  const [last, setLast] = useState(80);
  useEffect(() => { if (audioRef.current) audioRef.current.volume = volume / 100; }, [volume, audioRef]);
  const toggleMute = useCallback(() => {
    if (volume) { setLast(volume); setVolume(0); } else setVolume(last || 80);
  }, [volume, last]);
  return { volume, setVolume: (v) => setVolume(Math.max(0, Math.min(100, Math.round(v)))), toggleMute };
}
